import { Step, StepLabel, Stepper, StepperProps, SxProps, Typography } from '@mui/material';
import { Theme } from '@mui/system';
import { Dispatch, FC, SetStateAction } from 'react';
import StepperWrapper from '../../materio/@core/styles/stepper';
import StepperCustomDot from '../../materio/components/stepper-dot';
import { DsButton } from '../buttons/DsButton';

type StepType = { title: string; subtitle?: string; type?: 'text' | 'button'; path?: string; completed?: boolean };
type StepsType = number | StepType;

function isStep(obj: StepsType): obj is StepType {
  return (obj as StepType).title !== undefined;
}

export interface TDsStepperProps extends StepperProps {
  sxWrapper?: SxProps<Theme>;
  setStepOnClick?: Dispatch<SetStateAction<number>>;
  steps: StepType[] | number;
  withOutStepNum?: boolean;
  activeStep?: number;
  horizontalLineWidth?: number;
  textVariant?:
    | 'body2_500'
    | 'body1_500'
    | 'body1'
    | 'body2'
    | 'body3'
    | 'body3_500'
    | 'h6'
    | 'h5'
    | 'h4'
    | 'h3'
    | 'h2'
    | 'h1';
}

export const DsStepper: FC<TDsStepperProps> = ({
  sxWrapper,
  setStepOnClick,
  steps,
  withOutStepNum,
  horizontalLineWidth,
  activeStep,
  ...props
}) => {
  const stepArr = typeof steps === 'number' ? [...Array(steps).keys()] : steps;
  const { pathname } = window.location;
  /* const activeStepIndex =
    typeof steps !== 'number' ? stepArr.findIndex((step) => step?.path && pathname.includes(step.path)) : -1; */
  const activeStepIndex =
    typeof steps !== 'number'
      ? stepArr.findIndex((step) => isStep(step) && step.path && pathname.includes(step.path))
      : -1;
  const activeStp =
    activeStep === undefined && activeStepIndex > -1 ? activeStepIndex : activeStep ? activeStep - 1 : 0;
  return (
    <StepperWrapper sx={sxWrapper} className={`activeStep-${activeStp}`}>
      <Stepper
        activeStep={activeStp}
        {...props}
        sx={{
          ...(horizontalLineWidth && { '& .MuiStepConnector-horizontal': { maxWidth: `${horizontalLineWidth}px` } }),
        }}
      >
        {stepArr.map((step, index) => {
          return (
            <Step
              key={index}
              completed={typeof steps !== 'number' ? (step as StepType).completed : undefined}
              onClick={() => setStepOnClick?.(index)}
              sx={{
                ...(!setStepOnClick && {
                  '& .cursor-pointer': { cursor: 'default !important' },
                  '& .MuiStepLabel-iconContainer':
                    withOutStepNum && typeof steps === 'number' ? { paddingRight: 0 } : '',
                }),
              }}
            >
              <StepLabel StepIconComponent={StepperCustomDot}>
                <div className="step-label cursor-pointer">
                  {!withOutStepNum && (
                    <Typography
                      className={`${
                        typeof steps !== 'number' && isStep(step) && 'subtitle' in step
                          ? 'step-number'
                          : 'step-number-sm'
                      }`}
                      color="text.primary"
                    >{`0${index + 1}`}</Typography>
                  )}
                  {isStep(step) && step.type === 'button' ? (
                    <DsButton variant="contained" disabled={activeStep !== undefined && activeStep - 1 !== index}>
                      {(step as StepType).title}
                    </DsButton>
                  ) : (
                    typeof steps !== 'number' && (
                      <div>
                        <Typography className="step-title" color="text.primary">
                          {(step as StepType).title}
                        </Typography>
                        <Typography className="step-subtitle" color="text.primary">
                          {(step as StepType).subtitle}
                        </Typography>
                      </div>
                    )
                  )}
                </div>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </StepperWrapper>
  );
};
